module.exports = __webpack_public_path__ + "assets/f84f5da732ab3cdede9d4c3877b0b6f8.vtt";